import { render, staticRenderFns } from "./x-sukses.vue?vue&type=template&id=50239a07&scoped=true&"
import script from "./x-sukses.vue?vue&type=script&lang=js&"
export * from "./x-sukses.vue?vue&type=script&lang=js&"
import style0 from "./x-sukses.vue?vue&type=style&index=0&id=50239a07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50239a07",
  null
  
)

export default component.exports